import { useThaloWeb } from "@/contexts/ThaloWebContext";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { PaginatedResponse } from "@/api/api";
import { Meter } from "@/meters/meter";
import React from "react";

const useMonitoredMetersForOrganization = () => {
  const { selectedOrganization } = useThaloWeb();

  const [sorting, setSorting] = React.useState([{ id: "name", desc: false }]);
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const page = pagination.pageIndex + 1

  const buildUrl = (): string => {
    let url = `meters/`
    url += `?organization_id=${selectedOrganization?.id}`
    url += `&has_meter_monitor=True`
    url += `&page=${page}`
    url += `&page_size=${pagination.pageSize}`

    if (sorting?.length) {
      url += `&ordering=${sorting[0]?.desc ? "-" : ""}${sorting[0]?.id}`;
    }
    return url
  }


  const meters = useQuery({
    queryKey: [
      "monitoredMeters",
      selectedOrganization?.id,
      sorting
    ],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!selectedOrganization?.id,
    queryFn: async () => {
      return await apiClient.get<PaginatedResponse<Meter>>(buildUrl());
    },
  });

  return { meters, sorting, pagination, setSorting, setPagination }
}

export default useMonitoredMetersForOrganization;
